import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer tw-z-50">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Combo@Co.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Powered by : combosatco.in
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
